angular.module('aprima-legacy-common').provider('AppRoutes', ['_', function(_){
    'use strict';

    var appRoutes = {
        // These functions are used in Angular but not AngularJS.
        getAppRoutes: getAppRoutes,
        setupAppRoutes: setupAppRoutes,
    };

    this.setupAppRoutes = setupAppRoutes;
    
    function setupAppRoutes(newAppRoutes) {
        //does not overwrite existing properties
        _.defaults(appRoutes, newAppRoutes);
    }

    function getAppRoutes() {
        return appRoutes;
    }

    this.getAppRoutes = getAppRoutes;

    this.$get = [function(){
        return getAppRoutes();
    }];
}]);
